import { render, staticRenderFns } from "./SerProd.vue?vue&type=template&id=17eb2f31&scoped=true&"
import script from "./SerProd.vue?vue&type=script&lang=js&"
export * from "./SerProd.vue?vue&type=script&lang=js&"
import style0 from "./SerProd.vue?vue&type=style&index=0&id=17eb2f31&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17eb2f31",
  null
  
)

export default component.exports